export const LINKS_WITH_CONTENT = 'LinksWithContent';
export const LINKS_WITH_EVENTS = 'LinksWithEvents';
